import React, { Component, Fragment } from 'react';
import {
  Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane, Button, Row
} from 'reactstrap';
import { change, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import BasicDataPatient from './BasicDataPatient/BasicDataPatient';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import classnames from 'classnames';
import history from '../../../../history';
import ImagenologiaForm from './Imagenologia/ImagenologiaForm';
import KeyboardVoice from '@material-ui/icons/KeyboardVoice';
import Audiotrack from '@material-ui/icons/Audiotrack';
import AudioFileAdmision from '../../../AudioPanel/AudioFileAdmision';
import Tooltip from '@material-ui/core/Tooltip';
import AudioPanel from '../../../AudioPanel/AudioPanel';
import PatientInformation from '../../PatientInformation/PatientInformation';
import FormInterview from '../../../Interview/components/FormInterview';
import { faArrowRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from '@material-ui/core/IconButton';
import moment from 'moment';

class TabsBorderedTop extends Component {

  constructor() {
    super();
    this.state = {
      btnActive: true,
      activeTab: '1',
      loadTab: false,
      profile: sessionStorage.getItem('perfil'),
      stateClinicistory: false, //historia cerrada: true, abierta: false
      loading: true,
      historia_nuclear: {
        antecedentes: "",
        tecnica: "",
        descripcion: "",
        opinion: "",
        obseravcion: "",
        nota: ""
      },
      openAudioFileAdmision: false,
      panelRecordOpen: false,
      anotherPageHistory: false,
      refreshInfoPatient: {
        typeOfDocument: '',
        documentNumber: '',
        names: '',
        firstLastName: '',
        secondLastName: '',
        date: new Date(),
        birthday: new Date(),
        age: '',
        country: '',
        height: 0,
        weight: 0,
        imc: 0,
      },
      height: 0,
      weight: 0,
      informacion_femenina: {
        menopausia: null,
        embarazo: null,
        menstruacion: null,
        planificacion: null
      },
      dateFirstClosureClinicHistory: null, //Fecha de  cuando se cerró por primera la historiaClinica
      dateAtReopenClinicHistory: null, //Fecha de hasta cuando va a estar disponible reabrir la historia clinica
      third: null,
      infoPlanCurrentHistory: null
    }
  }

  componentDidMount() {
    if (!!this.props.data) {
      this.loadDataCita();
    }
    this.setState({ stateClinicistory: this.props.data.historia_cerrada, weight: this.props.data.peso, height: this.props.data.talla }, async () => {
      if (this.state.stateClinicistory) {
        this.checkClosureEventHistory();
      } else {
        this.loadDataTempletes();
      }
    });

  }

  loadDataTempletes = async () => {

    const id = sessionStorage.getItem('id_clinica');

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas/consultar?id_clinica=' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.plantilla !== null) {

          this.setState({
            historia_nuclear: {
              antecedentes: data.plantilla.historia_nuclear.antecedentes,
              tecnica: data.plantilla.historia_nuclear.tecnica,
              descripcion: data.plantilla.historia_nuclear.descripcion,
              opinion: data.plantilla.historia_nuclear.opinion,
              observacion: data.plantilla.historia_nuclear.observacion,
              nota: data.plantilla.historia_nuclear.nota
            },
          });
        }

      })
      .catch((error) => {
        console.error('Error:', error);

      });
  }


  handlerHeightDataInfo = (height) => {
    this.setState({ height: height })
  }

  handlerWeightDataInfo = (weight) => {
    this.setState({ weight: weight })
  }

  handlerDocumentNumberDataInfo = (number) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        documentNumber: number
      }
    }, () => {
      //this.loadDataPatient();
    });
  }

  handlerTypeOfDocumentDataInfo = (type) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        typeOfDocument: type
      }
    });
  }

  handlerNamesDataInfo = (names) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        names: names
      }
    });
  }

  handlerFirstLastNameDataInfo = (name) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        firstLastName: name
      }
    });
  }


  handlerSecondLastNameDataInfo = (name) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        secondLastName: name
      }
    });
  }

  handlerBirthDateDataInfo = (birthday) => {
    this.setState({ refreshInfoPatient: { ...this.state.refreshInfoPatient, ["birthday"]: birthday } },
      () => this.setState({ refreshInfoPatient: { ...this.state.refreshInfoPatient, ["birthday"]: birthday } }))
  }

  handlerAgeDataInfo = (age) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        age: age
      }
    });
  }

  handlerInfoFemMenopausia = (menopuasia) => {
    this.setState({ informacion_femenina: { ...this.state.informacion_femenina, menopausia: menopuasia } })
  }
  handlerInfoFemMenstruacion = (menstruacion) => {
    this.setState({ informacion_femenina: { ...this.state.informacion_femenina, menstruacion: menstruacion } })
  }
  handlerInfoFemPlanificacion = (planificacion) => {
    this.setState({ informacion_femenina: { ...this.state.informacion_femenina, planificacion: planificacion } })
  }
  handlerInfoFemEmbarazo = (embarazo) => {
    this.setState({ informacion_femenina: { ...this.state.informacion_femenina, embarazo: embarazo } })
  }

  checkClosureEventHistory = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar/cierre_historia_clinica/' + this.props.data.id_admision, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      } else {
        throw new Error("Ha ocurrido un error en el Servidor");
      }
    }).then(data => {
      console.log(data);
      if (!!data) {
        let firstClosureClinicHistory = data.fecha_cierre_1er_registro;
        let avaliableToReopenUntil = moment(firstClosureClinicHistory).add(12, 'hours');
        this.setState({ dateAtReopenClinicHistory: avaliableToReopenUntil, dateFirstClosureClinicHistory: firstClosureClinicHistory })
      }
    }).catch((error) => {
      console.error('Error:', error);
    });
  }

  reopenEventHistory = async () => {
    let dataSend = { id_admision: this.props.data.id_admision }
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/reabrir_historia', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      } else {
        throw new Error("Ha ocurrido un error en el Servidor");
      }
    }).then(data => {
      console.log(data);
      if (!!data) {
        this.setState({ stateClinicistory: false })
      }
    }).catch((error) => {
      console.error('Error:', error);
    });
  }

  loadDataCita = () => {

    var data = { id_cita: parseInt(this.props.data.id_cita) };

    fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/consultarpaciente', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({ infoPlanCurrentHistory: data.contenido.plan, third: data.contenido.third_info });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  };

  render() {
    const { activeTab } = this.state;

    const AudioListHistory = () => {
      return (<AudioFileAdmision data={this.props.data} id_admision={this.props.data.id_admision} audioRecOpen={this.state.openAudioFileAdmision} closeAudioRec={() => this.setState({ openAudioFileAdmision: false })} />);
    }

    return (
      <Col>
        <Col md={12}>

          <Row>
            <Col md={2}>
              <h3 style={{ marginBottom: 15 }}>Historia Cliníca</h3>

              <div className='top_info_buttons_hc_nuclear'>
                <div>
                  <Tooltip
                    title="Regresar a la Agenda "
                  >
                    <IconButton
                      aria-label="upload picture"
                      component="span"
                      className='tooltip-top'
                      onClick={() => {
                        history.push({
                          pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
                          state: {
                            date: this.props.data.fecha,
                            estado_list_form: this.props.data.estado_list_form,
                            pageIndex: this.props.pageIndex
                          }
                        });
                      }}
                    >
                      <ArrowBackIcon style={{ color: '#153365' }} />
                    </IconButton>
                  </Tooltip>
                  <span style={{ marginLeft: '0.25em' }}>Regresar a la Agenda</span>
                </div>
                <div className='button-actions-nuclear-hc'>
                  <div className='buttons_dest'>
                    <Tooltip title="Lista de Audios">
                      <Button
                        color="primary"
                        size="sm"
                        style={{ marginBottom: 3 }}
                        onClick={() => {
                          this.setState({ openAudioFileAdmision: true }, () => {
                            console.log(this.state.openAudioFileAdmision);
                          });
                        }}
                      > <Audiotrack />
                      </Button>
                    </Tooltip>
                  </div>
                  <div className='buttons_dest'>
                    <Tooltip title="Mostrar Panel de Grabación">
                      <Button
                        color="primary"
                        size="sm"
                        style={{ marginBottom: 3 }}
                        onClick={() => {
                          this.setState({ panelRecordOpen: !this.state.panelRecordOpen }, () => {
                            console.log("Cargando Modulo de Grabación...");
                          });
                        }}
                      > <KeyboardVoice />
                      </Button>
                    </Tooltip>
                  </div>
                </div>
                <div className='button-actions'>
                  {this.state.stateClinicistory === true || (this.state.profile !== "9" && this.state.profile !== "10") ?
                    !!this.state.dateAtReopenClinicHistory && !!this.state.dateFirstClosureClinicHistory ?
                      moment().isBetween(moment(this.state.dateFirstClosureClinicHistory), moment(this.state.dateAtReopenClinicHistory), 'second') ?
                        <Fragment>
                          <div>
                            <Button
                              color="primary"
                              size="sm"
                              style={{ marginBottom: 3 }}
                              onClick={() => {
                                this.reopenEventHistory();
                              }}
                            >
                              <FontAwesomeIcon icon={faArrowRotateLeft} />
                              Reabrir Historia Clínica
                            </Button>
                          </div>
                          <div>
                            <span>Esta Historia Clínica se puede volver abrir hasta las <b>{moment(this.state.dateAtReopenClinicHistory).tz("America/Bogota").format('h:mm a')}</b> del día <b>{moment(this.state.dateAtReopenClinicHistory).tz("America/Bogota").format('DD-MM-YYYY')} </b></span>
                          </div>
                        </Fragment>
                        : null
                      : null
                    :
                    null
                  }
                </div>
              </div>
            </Col>
            <Col md={10}>
              <PatientInformation
                num_documento={this.props.data.num_documento}
                nombres={this.props.data.nombres}
                tip_documento={this.props.data.tip_documento}
                birthday={this.props.data.birthday}
                remitente={this.props.data.remitente}
                servicio={this.props.data.servicio}
                infoPatient={this.props.data}
                weight={this.state.weight}
                height={this.state.height}
                refreshInfoPatient={this.state.refreshInfoPatient}
                riesgo_caidas={this.props.data.riesgo_caidas}
                requerimientos_especiales={this.props.data.requerimientos_especiales}
                id_admision={this.props.data.id_admision}
                stateClinicHistory={this.state.stateClinicistory}
                thirdInfo={this.state.third}
                infoPlanCurrentHistory={this.state.infoPlanCurrentHistory}
              />
              <AudioListHistory />
            </Col>
          </Row>
        </Col>
        <Card>
          <CardBody>
            {
              this.state.panelRecordOpen == true ?
                <>
                  <div>
                    <AudioPanel id_admision={this.props.data.id_admision} id_historia={this.props.data.id_historia} />
                    <br />
                    <Button
                      color="primary"
                      style={{ marginTop: 50 }}
                      onClick={() => {
                        this.setState({ panelRecordOpen: !this.state.panelRecordOpen }, () => {
                          console.log("Cerrando Modulo de Grabación...");
                        });
                      }}
                    >
                      Ocultar Panel de Grabación
                    </Button>
                  </div>
                </>
                : null
            }
            <div className="tabs tabs--bordered-top">
              <div className="tabs__wrap">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => {
                        this.toggle('1');
                      }}
                    >
                      Datos Básicos
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => {
                        this.toggle('2');
                      }}
                    >
                      Entrevista
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => {
                        this.toggle('3');
                      }}
                    >
                      Imagenologia
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <BasicDataPatient
                      data={this.props.data}
                      num_documento={this.props.data !== undefined ? this.props.data.num_documento : this.props.location.state.dataPatient.num_documento}
                      handlerHeight={this.handlerHeightDataInfo} handlerWeight={this.handlerWeightDataInfo}
                      handlerDocumentNumberDataInfo={this.handlerDocumentNumberDataInfo}
                      handlerTypeOfDocumentDataInfo={this.handlerTypeOfDocumentDataInfo}
                      handlerNamesDataInfo={this.handlerNamesDataInfo}
                      handlerFirstLastNameDataInfo={this.handlerFirstLastNameDataInfo}
                      handlerSecondLastNameDataInfo={this.handlerSecondLastNameDataInfo}
                      handlerBirthDateDataInfo={this.handlerBirthDateDataInfo}
                      handlerAgeDataInfo={this.handlerAgeDataInfo}
                      refreshInfoPatient={this.state.refreshInfoPatient}
                      height={this.state.height} weight={this.state.weight}
                      informacion_femenina={this.state.informacion_femenina}
                      handlerInfoFemMenopausia={this.handlerInfoFemMenopausia}
                      handlerInfoFemMenstruacion={this.handlerInfoFemMenstruacion}
                      handlerInfoFemPlanificacion={this.handlerInfoFemPlanificacion}
                      handlerInfoFemEmbarazo={this.handlerInfoFemEmbarazo} /> {/*this.props.data.num_documento*/}
                  </TabPane>
                  <TabPane tabId="2">
                    <FormInterview dataPatient={this.props.data} seeInputDiag={this.state.anotherPageHistory} />
                  </TabPane>
                  <TabPane tabId="3">
                    <ImagenologiaForm data={this.props.data} history={this.state.historia_nuclear} />
                  </TabPane>
                </TabContent>
              </div>
            </div>
            <div>

              {/*this.state.stateClinicistory === "Cerrada" || this.state.profile === "12" ? null :
                    <Button                      
                      style={{ marginTop: 50 }}
                      onClick={() => { 
                        this.createHistory()
                      }}
                    >
                     Guardar
                    </Button>*/}
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

}

export default reduxForm({
  form: 'clinic_history_form', // a unique identifier for this form
})(withTranslation('common')(TabsBorderedTop));